// Storage access that never throws (Safari private mode, blocked cookies, sandboxed iframes)
const storage = (type) => {
  try { return window[type]; } catch (e) { return null; }
};

export const storageGet = (type, key) => {
  try { return storage(type)?.getItem(key) ?? null; } catch (e) { return null; }
};

export const storageSet = (type, key, value) => {
  try { storage(type)?.setItem(key, value); } catch (e) { /* ignore */ }
};

export const storageRemove = (type, key) => {
  try { storage(type)?.removeItem(key); } catch (e) { /* ignore */ }
};
